import { setMachineReportDetailsData } from '../../../../redux/machineReportDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../../utils/CustomErrorLogger';
import MachineReportDetailsHeader from './machineReportDetailsHeader';
import { useHasPermission } from '../../../../hooks/useHasPermission';
import MachineReportDetailsInfo from './machineReportDetailsInfo';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { useParams, useLocation } from 'react-router';
import PdfDocuments from '../../../pdfDocuments';
import { saveAs } from 'file-saver';
import axios from 'axios';

const MachineReportDetails = () => {

    const { id } = useParams();
    const location = useLocation();

    const dispatch = useDispatch();
    const hasReportUpdatePermission = useHasPermission('controls_update');
    const machineReportDetailsData = useSelector((state) => state?.MachineReportDetailsData);

    const [loading, setLoading] = useState(true);
    const [pdfId, setPdfId] = useState(null);
    const [openDeletePDF, setOpenDeletePDF] = useState(false);

    const fetchMachineReportDetails = useCallback(async () => {
        try {
            const response = await axios.get(`machine-control/${id}`);
            if ((response.status === 200 || response.status === 201) && response.data) {
                dispatch(setMachineReportDetailsData(response.data));
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error Fetching machine_report:', error);
            CustomErrorLogger(error, "Fetch machine_report Details Error in MachineReportDetails");
        }
    }, [dispatch, id]);

    useEffect(() => {
        fetchMachineReportDetails()
    }, [fetchMachineReportDetails, dispatch]);

    const handleUploadDocuments = async (files) => {
        try {
            const formData = new FormData();
            Array.from(files).forEach(file => {
                if (file.type === "application/pdf") {
                    formData.append('files', file);
                } else {
                    console.error("Invalid file format");
                }
            });
            formData.append('control_id', machineReportDetailsData.id); // assuming machineReportDetailsData has the id

            const response = await axios.post('machine-control-document', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200 || response.status === 201) {
                // Assuming the response.data contains the array of uploaded documents
                const uploadedDocuments = [...machineReportDetailsData.machine_control_document, ...response.data];
                dispatch(setMachineReportDetailsData({
                    ...machineReportDetailsData,
                    machine_control_document: uploadedDocuments
                }));
            }

        } catch (error) {
            console.error('Error uploading documents:', error);
            CustomErrorLogger(error, 'Error uploading documents');
        }
    };

    const handleDawnloadAllDocument = async () => {
        try {
            const response = await axios.get(`machine-control-document/downloadAll/${machineReportDetailsData.id}`, { responseType: 'blob' });
            if (response.status === 200 || response.status === 201) {
                const filename = response.headers['content-disposition']
                    ?.split('filename=')[1]
                    ?.replace(/"/g, '')
                    || `report-${machineReportDetailsData.id}-documents.zip`;

                saveAs(new Blob([response.data]), filename);
            }
        } catch (error) {
            console.error('Error dawnloading document:', error);
            CustomErrorLogger(error, 'Error dawnloading document');
        }
    };

    const handleDawnloadDocument = async (doc) => {
        try {
            const response = await axios.get(`machine-control-document/${doc.id}`, { responseType: 'blob' });
            if (response.status === 200 || response.status === 201) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                saveAs(blob, doc.name);
            }
        } catch (error) {
            console.error('Error dawnloading document:', error);
            CustomErrorLogger(error, 'Error dawnloading document');
        }
    };

    const handleRemoveAllDocument = async () => {
        try {
            const response = await axios.delete(`machine-control-document/deleteAll/${machineReportDetailsData.id}`);

            if (response.status === 200 || response.status === 201) {
                dispatch(setMachineReportDetailsData({
                    ...machineReportDetailsData,
                    machine_control_document: []
                }));
                setOpenDeletePDF(false);
            }

        } catch (error) {
            console.error('Error deleting document:', error);
            CustomErrorLogger(error, 'Error deleting document');
        }
    };

    const handleRemoveDocument = async (id) => {
        try {
            const response = await axios.delete(`machine-control-document/${id}`);

            if (response.status === 200 || response.status === 201) {
                dispatch(setMachineReportDetailsData({
                    ...machineReportDetailsData,
                    machine_control_document: machineReportDetailsData.machine_control_document.filter(doc => doc.id !== id)
                }));
                setOpenDeletePDF(false);
            }

        } catch (error) {
            console.error('Error deleting document:', error);
            CustomErrorLogger(error, 'Error deleting document');
        }
    };

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <MachineReportDetailsHeader fromMachinePage={location.state.fromMachinePage} />
                    <MachineReportDetailsInfo />
                    <Box className='readMachineReport_box'>
                        <PdfDocuments
                            documents={machineReportDetailsData?.machine_control_document}
                            hasUpdatePermission={hasReportUpdatePermission && !machineReportDetailsData?.machine?.is_archived}
                            handleUploadDocuments={handleUploadDocuments}
                            handleDawnloadAllDocument={handleDawnloadAllDocument}
                            handleDawnloadDocument={handleDawnloadDocument}
                            handleRemoveAllDocument={handleRemoveAllDocument}
                            handleRemoveDocument={handleRemoveDocument}
                            openDeletePDF={openDeletePDF}
                            setOpenDeletePDF={setOpenDeletePDF}
                            pdfId={pdfId}
                            setPdfId={setPdfId}
                        />
                    </Box>
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default MachineReportDetails;